"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiddingStrategyConfiguration = void 0;
class BiddingStrategyConfiguration {
    /** Deprecated: used by old-version strategy */
    biddingStrategyId;
    biddingStrategyType = "TARGET_CPA";
    bids;
}
exports.BiddingStrategyConfiguration = BiddingStrategyConfiguration;
//# sourceMappingURL=BiddingStrategyConfiguration.js.map